import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const CUSTOM_RULE_EDITOR_CLASS_NAME = 'CustomRuleEditor';
export const CUSTOM_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type CustomRuleEditorClassSlot =
	(typeof CUSTOM_RULE_EDITOR_CLASS_SLOTS)[number];

export interface CustomRuleEditorClasses {
	root: string;
}

export type CustomRuleEditorClassKey = keyof CustomRuleEditorClasses;

export const getCustomRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(CUSTOM_RULE_EDITOR_CLASS_NAME, slot);

export const customRuleEditorClasses: CustomRuleEditorClasses =
	generateUtilityClasses(CUSTOM_RULE_EDITOR_CLASS_NAME, ['root']);

export default customRuleEditorClasses;
